import { PartnerDetailPage } from "@/features/partner/pages/PartnerDetail";

const PartnerDetail = () => {
  return <PartnerDetailPage />;
};

export default PartnerDetail;
